import * as api from "@/api";
import router from "@/router";

const initState = () => ({
  smsid: "",
  phone: "",
  pass: "",
  code: "",
  stage: ""
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    stage: state => state.stage,
    pass: state => state.pass,
    code: state => state.code,
    phone: state => state.phone,
    phoneNumber: state => state.phone.replace(/\D/g, "")
  },
  mutations: {
    reset: state => {
      const initialState = initState();
      Object.keys(initialState).forEach(key => (state[key] = initialState[key]));
    },
    setPass: (state, value) => (state.pass = value),
    setSmsid: (state, value) => (state.smsid = value),
    setPhone: (state, value) => (state.phone = value),
    setCode: (state, code) => (state.code = code),
    setStage: (state, stage) => (state.stage = stage)
  },
  actions: {
    async login(ctx, data) {
      const res = await api.login(data);

      if (res) {
        router.push({ path: "/cabinet/main" });
      }
    },

    async init({ commit, getters: { phoneNumber } }) {
      const res = await api.initRecovery(phoneNumber);
      if (res) {
        commit("setSmsid", res.smsid);
        commit("setStage", "confirmation");
      }
    },

    async confirm({ commit, state: { smsid, code } }) {
      const res = await api.confirmRecovery(smsid, code);
      if (res) {
        commit("setStage", "password");
      }
    },

    async refresh({ commit, getters: { phoneNumber } }) {
      const res = await api.refreshRecovery(phoneNumber);
      if (res) {
        commit("setSmsid", res.smsid);
      }
    },

    async recovery({ state: { smsid, pass } }) {
      const res = await api.recovery(smsid, pass);
    }
  }
};
